import { render, staticRenderFns } from "./QuoteDiscountPercentTextField.vue?vue&type=template&id=2db6b2d1&"
import script from "./QuoteDiscountPercentTextField.vue?vue&type=script&lang=ts&"
export * from "./QuoteDiscountPercentTextField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports